module.exports = __webpack_public_path__ + "static/media/option-4.01d0521f.ogg";